import { Environment } from './Environment';

import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';

export default class TeamsService {

  public static getPosts(environment: "Development" | "Test" | "Production", token: string, tenant: string): Promise<any[]> {
    return new Promise<any[]>((resolve: (result: any[]) => void): void => {
      if (environment && tenant && token) {
        const url = Environment.getEnvironmentForTeamsAPI(environment) + `/${tenant}/messages`;
        new FetchProxy(url, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            return response.status;
          } else {
            return response.json();
          }
        }).then(response => {
          console.log(response);
          resolve(response);
        }).catch((error) => {
          console.log(error);
        });
      } else {
        resolve(null);
      }
    });
  }
}